import HMNICard from "../components/HMNICard";
import Experience from "../components/Experience";
import Projects from "../components/Projects";
import Footer from "../components/Footer";

import { KeyBoardDoubleArrowDown } from "../components/Icons";

import style from "../style/Home.module.css"

function Home() {
    return (
        <>
            <title>Emil Albrecht</title>
            <header className={style.header}>
                <HMNICard />
                <KeyBoardDoubleArrowDown className={style.headerArrow} />
            </header>

            <main>
                <Experience />
                <div className={style.sectionSpacer}></div>
                <Projects />
            </main>

            <div className={style.koalaContainer}>
                <div className={style.koala}></div>
            </div>

            <footer style={{ boxShadow: "0 -3em 2em 1.5em rgba(90, 138, 34, 0.69)" }}><Footer /></footer>
        </>
    );
}

export default Home;
